import * as React from 'react';
import { Placement } from '../placement';
import { useAdSense } from '../../hooks/adSense';
import { AdSenseForShopping } from '../ad-sense-for-shopping';
import { useDeviceType } from '../../hooks/deviceType';

import {
    SearchResultBannersSpacing,
    Props,
} from './search-result-banners-server';
import { getConfig } from '../../config';
import { useCallback } from 'react';

export function getType(index: number, showAdSenseBoards: boolean) {
    const config = getConfig();
    const hasContentMarketing = config?.contentMarketing?.length > 0;
    if (hasContentMarketing && index === 2) {
        return 'content-marketing';
    }
    if (index !== 1 && showAdSenseBoards) {
        return 'shopping';
    }
    return 'ast';
}

const SearchResultBannersClient: React.FC<Props> = (props) => {
    const {
        cols = 1,
        vertical,
        subvertical,
        deviceType: deviceTypeFromServer,
        searchSummary,
    } = props;

    const deviceType = useDeviceType(deviceTypeFromServer);
    const children = React.Children.toArray(props.children);

    const { showAdSense, showAdSenseBoards } = useAdSense(
        children,
        deviceType,
        vertical,
        searchSummary,
        cols !== 1,
        children.length === 0,
    );

    const spacer = useCallback(
        (id, index) => (
            <Placement
                id={id}
                grid={cols !== 1}
                vertical={vertical}
                subvertical={subvertical}
                key={id}
                deviceType={deviceType}
                showBanners={true}
                type={getType(index, showAdSenseBoards)}
            />
        ),
        [cols, deviceType, vertical, subvertical, showAdSenseBoards],
    );

    return (
        <>
            <SearchResultBannersSpacing
                deviceType={deviceType}
                cols={cols}
                vertical={vertical}
                subvertical={subvertical}
                spacer={spacer}
            >
                {children}
            </SearchResultBannersSpacing>
            {showAdSense && (
                <AdSenseForShopping
                    id="afshcontainer"
                    deviceType={deviceType}
                />
            )}
        </>
    );
};

export default SearchResultBannersClient;
